import { useEffect } from 'react';

function BackgroundPattern() {
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');

    const apply = () => {
      const isMobile = mq.matches;
      const url = isMobile ? '/assets/pattern_mob.png' : '/assets/pattern_pc.png';
      document.body.style.backgroundImage = `url(${url})`;
      document.body.style.backgroundRepeat = 'repeat';
      document.body.style.backgroundSize = 'auto';
      document.body.style.backgroundAttachment = '';
    };

    apply();
    mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);

    return () => {
      mq.removeEventListener ? mq.removeEventListener('change', apply) : mq.removeListener(apply);
    };
  }, []);

  return null;
}

export default BackgroundPattern;
